import { render, staticRenderFns } from "./CertificationModal.vue?vue&type=template&id=4dd2e59a&scoped=true"
import script from "./CertificationModal.vue?vue&type=script&lang=js"
export * from "./CertificationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd2e59a",
  null
  
)

export default component.exports